<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import BarraPaginacao from '../../componentes/BarraPaginacao.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let parseDistribuicao = [];
	let headerAuth = "";
	let paginaAnterior, paginaAtual, proximaPagina, totalResultados, ultimaPagina, resultadosPorPagina;
	let objetoDistribuidoEProjetoFlagRota = "";

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarDistribuicaoAPI(1);
		else 
			replace("/login");
	});

	const carregarDistribuicaoAPI = async (pagina) => {
		parseDistribuicao = [];
		let dados;

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		const resposta = await fetch(API(`distribuicao?page=${pagina}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			dados = json.dados;

			/**
			 * atribui os valores da resposta da paginação atual 
			 * (estas atribuições devem ocorrer antes de adicionar valores no parseAfirmacoes 
			 * com o push pois caso contrário a referência a página atual fica errada / atrasada)
			 */
			paginaAtual = dados.meta.current_page;
			paginaAnterior = paginaAtual - 1;
			proximaPagina = paginaAtual + 1;
			totalResultados = dados.meta.total;
			ultimaPagina = dados.meta.last_page;
			resultadosPorPagina = dados.meta.per_page;
			objetoDistribuidoEProjetoFlagRota = dados.data[0].objetoDistribuidoEProjeto == true ? 'PROJETO' : 'APRESENTACAO';
			
			dados.data.forEach( distribuicao => {
				let flagAceita = distribuicao.data_aceite == null 
					? `Aguardando aceite` 
					: `Aceita em ${distribuicao.data_aceite}`;

				if (distribuicao.objetoDistribuidoEProjeto == true) {

					parseDistribuicao.push({
						link: '#',
						titulo: `#${distribuicao.id} - Projeto distribuído para o(a) avaliador(a) ${distribuicao.avaliador.nome}`,
						tag: flagAceita,
						descricao: `Distribuição realizada em ${distribuicao.data_distribuicao}`,
						acoes: [{
							url: `#/usuario/visualizar/${distribuicao.avaliador.cpf}`,
							texto: 'Visualizar avaliador(a)'
						}, {
							url: `#/projeto/visualizar/${distribuicao.objetoDistribuido.codigo}`,
							texto: `Visualizar projeto`
						}, {
							url: `#/distribuicao/desfazer/confirmacao/${distribuicao.id}`,
							texto: '[ Desfazer ]'
						}]
					});
				} else {
					parseDistribuicao.push({
						link: '#',
						titulo: `#${distribuicao.id} - Apresentação (semana de graduação) distribuída para o(a) avaliador(a) ${distribuicao.avaliador.nome}`,
						tag: flagAceita,
						descricao: `Distribuição realizada em ${distribuicao.data_distribuicao}`,
						acoes: [{
							url: `#/usuario/visualizar/${distribuicao.avaliador.cpf}`,
							texto: 'Visualizar avaliador(a)'
						}, {
							url: `#/apresentacao/visualizar/${distribuicao.objetoDistribuido.id}/${distribuicao.objetoDistribuido.projeto?.codigo}`,
							texto: `Visualizar apresentação`
						}, {
							url: `#/distribuicao/desfazer/confirmacao/${distribuicao.id}`,
							texto: '[ Desfazer ]'
						}]
					});
				}
			});

			parseDistribuicao = [...parseDistribuicao];
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: json?.mensagem ?? 'Erro desconhecido na listagem da distribuição.'
			});
			
			replace("/painel");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Distribuição Atual">
	
	<BarraPaginacao 
		callback={carregarDistribuicaoAPI}
		paginaAnterior={paginaAnterior}
		paginaAtual={paginaAtual}
		proximaPagina={proximaPagina}
		ultimaPagina={ultimaPagina}
		totalResultados={totalResultados}
		resultadosPorPagina={resultadosPorPagina}/>
		
		<div class="columns">
			<div class="column has-text-right">
				<p>Outras opções: 
					<strong><a href="#/distribuicao/listagem-por-avaliador/{objetoDistribuidoEProjetoFlagRota}">Visão geral por avaliador(a)</a></strong>
					| <strong><a href="#/distribuicao/listagem-aguardando-aceite-admin/{objetoDistribuidoEProjetoFlagRota}">Aceite pendente</a></strong>
				</p>
			</div>
		</div>

	<GradeCartoes itens={parseDistribuicao} componente={CartaoRetangulo} flexWrap={false} />
</PainelBox>
